import { render, staticRenderFns } from "./PhieuNhapVien.vue?vue&type=template&id=a8353b42&scoped=true"
import script from "./PhieuNhapVien.vue?vue&type=script&lang=js"
export * from "./PhieuNhapVien.vue?vue&type=script&lang=js"
import style0 from "./PhieuNhapVien.vue?vue&type=style&index=0&id=a8353b42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8353b42",
  null
  
)

export default component.exports